import * as stylex from "@stylexjs/stylex";
import React from "react";
import { breakpoints, layoutAreas } from "./consts.stylex";
import * as L from "./layout";
const gridStyles = {
    simple: {
        k1xSpc: "xrvj5dj",
        kGNEyG: "x7a106z",
        k1K539: "xat24cr",
        koQZXg: "xj3b58b",
        km5ZXQ: "x1yf7rl7",
        kHMzQL: "xmqsug5 xqt94hq",
        kumcoG: "x18fdjwo x1a3oxht xwbab6e xj3l5gd",
        $$css: true
    },
    focus: {
        k1xSpc: "xrvj5dj",
        kGNEyG: "x7a106z",
        k1K539: "x8xy4a3",
        koQZXg: "xj3b58b",
        km5ZXQ: "x1yf7rl7",
        kHMzQL: "xmqsug5 xjilcdy",
        kumcoG: "x18fdjwo x1nj37k0",
        $$css: true
    },
    full: {
        k1xSpc: "xrvj5dj",
        kGNEyG: "x7a106z",
        kHMzQL: "xmqsug5 xqt94hq",
        kumcoG: "x18fdjwo x1a3oxht xs6o9dq xf0c710",
        $$css: true
    },
    explorer: {
        k1xSpc: "xrvj5dj",
        kGNEyG: "x7a106z",
        kHMzQL: "xmqsug5 xqt94hq",
        kumcoG: "x18fdjwo x1a3oxht xs6o9dq xpn7u5s",
        $$css: true
    },
    article: {
        k1xSpc: "xrvj5dj",
        kGNEyG: "x7a106z",
        kHMzQL: "xmqsug5 xqt94hq",
        kumcoG: "x18fdjwo x1a3oxht xwbab6e x4s1ce7",
        $$css: true
    },
    articleNarrow: {
        k1xSpc: "xrvj5dj",
        kGNEyG: "x7a106z",
        kHMzQL: "xmqsug5 xqt94hq",
        kumcoG: "x18fdjwo x1a3oxht xwbab6e xt1cvyj",
        $$css: true
    },
    home: {
        k1xSpc: "xrvj5dj",
        kGNEyG: "x7a106z",
        kmkexE: "xmn30zs",
        kWkggS: "x1bhzn2a",
        kHMzQL: "xmqsug5 xqt94hq",
        kumcoG: "x18fdjwo x1a3oxht xs6o9dq xptvmiw",
        $$css: true
    }
};
export const Grid = ({ children, layout, sx, as = "div", className, style })=>{
    const wrapperProps = React.useMemo(()=>{
        const layoutStyle = L.foldLayout(layout, {
            home: ()=>gridStyles.home,
            simple: ()=>gridStyles.simple,
            article: ()=>gridStyles.article,
            articleNarrow: ()=>gridStyles.articleNarrow,
            full: ()=>gridStyles.full,
            explorer: ()=>gridStyles.explorer,
            focus: ()=>gridStyles.focus,
            none: ()=>undefined
        });
        const sxProps = sx ? stylex.props(layoutStyle, ...sx) : stylex.props(layoutStyle);
        return {
            className: [
                "grid-root",
                layout === "focus" && "grid-layout-focus",
                className,
                sxProps.className
            ].filter(Boolean).join(" ") || undefined,
            style: sxProps.style ? {
                ...sxProps.style,
                ...style
            } : style
        };
    }, [
        layout,
        sx,
        className,
        style
    ]);
    return React.createElement(as, wrapperProps, children);
};
